const state = {
  customers: [],
  page: 1,
  search: '',
  status: 'active',
  categories: [],
  myCustomers: true,
  read: null,
  unreadMessages: false,
  premiumUsers: false,
};

const getters = {
  params(state) {
    return {
      search: {
        search: state.search,
      },
      myCustomers: state.myCustomers,
      status: state.status,
      users: state.customers,
      categories: state.categories,
      page: state.page,
      read: state.read,
      unreadMessages: state.unreadMessages,
      premiumUsers: state.premiumUsers,
      where: {}, // TODO: remove or complete
    };
  },
  search(state) {
    return state.search;
  },
  myCustomers(state) {
    return state.myCustomers;
  },
  status(state) {
    return state.status;
  },
  customers(state) {
    return state.customers;
  },
  categories(state) {
    return state.categories;
  },
  page(state) {
    return state.page;
  },
  read(state) {
    return state.read;
  },
  unreadMessages(state) {
    return state.unreadMessages;
  },
  premiumUsers(state) {
    return state.premiumUsers;
  },
};

const mutations = {
  params(state, data) {
    state.search = data.search.search;
    state.myCustomers = data.myCustomers;
    state.status = data.status;
    state.customers = data.users;
    state.categories = data.categories;
    state.page = data.page;
    state.read = data.read;
    state.unreadMessages = data.unreadMessages;
    state.premiumUsers = data.premiumUsers();
  },

  customers(state, data) {
    state.page = 1;
    state.customers = data;
  },
  page(state, data) {
    state.page = data;
  },
  search(state, data) {
    state.page = 1;
    state.search = data;
  },
  status(state, data) {
    state.page = 1;
    state.status = data;
  },
  categories(state, data) {
    state.page = 1;
    state.categories = data;
  },
  myCustomers(state, data) {
    state.page = 1;
    state.myCustomers = data;
  },
  read(state, data) {
    state.page = 1;
    state.read = data;
  },
  unreadMessages(state, data) {
    state.page = 1;
    state.unreadMessages = data;
  },
  premiumUsers(state, data) {
    state.page = 1;
    state.premiumUsers = data;
  },
};

const actions = {
  resetParams: function({ dispatch, commit, getters, rootGetters }) {
    const categories = rootGetters.userCategoriesNames;

    commit('params', {
      search: {
        search: '',
      },
      myCustomers: true,
      status: 'active',
      users: [],
      categories: categories,
      page: 1,
      where: {},
      read: null,
      unreadMessages: false,
      premiumUsers: false,
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
